import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'sera-page-header',
    templateUrl: './sera-page-header.component.html',
    styleUrls: ['./sera-page-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraPageHeaderComponent {
    @Input()
    headerIcon!: string;
    @Input()
    breadcrumbElements!: string[];
}
